<template>
  <MainLayout activeIndex="1">
    <el-row :gutter="20">
      <el-col :span="8" v-for="item in classroomList" :key="item.id">
        <ClassroomCard
          :title="item.name"
          :teacher_name="item.teacher_name"
          :description="item.description"
          :classroom_id="item.id"
          :avatar="item.avatar"
        />
      </el-col>
    </el-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import { getClassrooms } from "@/api";
import ClassroomCard from "@/components/ClassroomCard";

export default {
  name: "ClassroomList",
  components: {
    MainLayout,
    ClassroomCard
  },
  data() {
    return {
      classroomList: []
    };
  },
  mounted() {
    this.getClassroomList();
  },
  methods: {
    getClassroomList() {
      getClassrooms().then(res => {
        this.classroomList = [];
        res.forEach((item, index) =>
          this.classroomList.push({
            index,
            ...item
          })
        );
      });
    }
  }
};
</script>

<style>
</style>